import styled from 'styled-components';

export const StyledDesktopButtonIconLink = styled.a`
  width: auto;
  padding: 0 5px;
  height: 30px;
  align-self: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  flex: 0 0 auto;
  gap: 10px;
  color: var(--color-text-muted);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;

  :hover {
    background: #cadcf8;
    color: var(--color-surface);
  }
`;
